import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getLocaleMessages from '../../utils/localesMessages';

const {
	yourLogo,
	logoAltText
} = getLocaleMessages('buttons/wizardStepTwo');

class LogoPreview extends Component {
	static propTypes = {
		logoImageUrl: PropTypes.string,
		onError: PropTypes.func
	}

	render() {
		return (
			<div className="logo-container">
				<div className="logo">
					{
						!this.props.logoImageUrl ?
						<div className="logo-preview">
							<p>{yourLogo}</p>
						</div> :
						<img
							src={this.props.logoImageUrl}
							alt={logoAltText}
							onError={(error) => {
								if (this.props.onError) {
									this.props.onError(error);
								}
							}}
						/>
					}
				</div>
			</div>
		);
	}
}
export default LogoPreview;



// WEBPACK FOOTER //
// ./buttons/components/logo/LogoPreview.js